<div class="_result"
     sizeClass="SM:c2, XL:c1"
     [ngClass]="status.error ? 'col-2' : 'col-3'"
     [innerHTML]="message || (holdPlace ? '&nbsp' : '')"></div>